var props = {
    MuiSwitch: {
        color: 'default',
    },
    MuiTextField: {
        variant: 'outlined',
    },
};

export { props };
//# sourceMappingURL=props.js.map
